import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { MeResponse, Role } from "@mubin/contracts";
import { api, storeRole } from "./api";

export const meQuery = {
  queryKey: ["me"],
  queryFn: () => api<MeResponse>("/v1/me"),
  staleTime: 60_000,
} as const;

export function useMe() {
  return useQuery(meQuery);
}

export function useRoleSwitch() {
  const qc = useQueryClient();
  return async (role: Role) => {
    storeRole(role);
    // Every cached response depends on the active role; drop them all.
    await qc.resetQueries();
  };
}

export async function logout(qc: ReturnType<typeof useQueryClient>) {
  await api("/v1/auth/logout", { method: "POST" }).catch(() => undefined);
  storeRole(null);
  qc.clear();
}
